// Auth API for DIOS10 - Email/Password authentication
import apiClient from './client';
import { API_ENDPOINTS } from './config';
import { usersApi } from './users';
import { setStoredLanguage } from '../utils/locale';

export const authApi = {
    // Register with email and password
    register: async (userData) => {
        try {
            const response = await apiClient.post(API_ENDPOINTS.USERS.REGISTER, {
                username: userData.username,
                email: userData.email,
                password: userData.password,
                referralCode: userData.referralCode
            });
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Login with email and password
    login: async (email, password) => {
        try {
            const response = await apiClient.post(API_ENDPOINTS.USERS.LOGIN, {
                email,
                password
            });
            
            // Store token and user if provided
            if (response.token) {
                localStorage.setItem('authToken', response.token);
            }
            if (response.user) {
                let storedUser = response.user;
                const isAdmin = response.user?.isAdmin === true;

                // Fetch full user profile for onboarding fields (tutorial_completed, language)
                if (!isAdmin && response.user.id) {
                    try {
                        const userResponse = await usersApi.getById(response.user.id);
                        if (userResponse?.user) {
                            const fullUser = userResponse.user;
                            storedUser = {
                                ...response.user,
                                ...fullUser,
                                walletAddress: fullUser.wallet_address || response.user.walletAddress,
                                referralCode: fullUser.referral_code || response.user.referralCode
                            };
                        }
                    } catch {
                        // Keep minimal user data if refresh fails
                    }
                }

                localStorage.setItem('user', JSON.stringify(storedUser));
                if (storedUser?.language) {
                    setStoredLanguage(storedUser.language);
                }
            }
            
            return response;
        } catch (error) {
            throw error;
        }
    },

    // Logout
    logout: async () => {
        try {
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
            return { success: true };
        } catch (error) {
            throw error;
        }
    },

    // Check if user is authenticated
    checkAuth: async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return { authenticated: false };
            }
            
            const response = await apiClient.get(API_ENDPOINTS.USERS.CHECK_AUTH);
            return response;
        } catch (error) {
            localStorage.removeItem('authToken');
            return { authenticated: false };
        }
    },

    // Get current user
    getCurrentUser: () => {
        try {
            const userStr = localStorage.getItem('user');
            return userStr ? JSON.parse(userStr) : null;
        } catch {
            return null;
        }
    }
};

export default authApi;

